var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"ds-btn",class:{'ds-btn--disabled': _vm.isActiveRequest},attrs:{"disabled":_vm.isActiveRequest},on:{"click":_vm.handleExport}},[_vm._v(" Eksportēt ")])}
var staticRenderFns = []

export { render, staticRenderFns }